/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsChangeLicenseLevel
 */
export interface ControlcenterMelcoControlCenterModelsChangeLicenseLevel {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    referral_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    serial_number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    step?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    language?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    renewal_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsChangeLicenseLevel
     */
    expiration_date?: Date | null;
}

export function ControlcenterMelcoControlCenterModelsChangeLicenseLevelFromJSON(json: any): ControlcenterMelcoControlCenterModelsChangeLicenseLevel {
    return ControlcenterMelcoControlCenterModelsChangeLicenseLevelFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsChangeLicenseLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsChangeLicenseLevel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'step': !exists(json, 'step') ? undefined : json['step'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'renewal_date': !exists(json, 'renewal_date') ? undefined : (json['renewal_date'] === null ? null : new Date(json['renewal_date'])),
        'expiration_date': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
    };
}

export function ControlcenterMelcoControlCenterModelsChangeLicenseLevelToJSON(value?: ControlcenterMelcoControlCenterModelsChangeLicenseLevel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'version_id': value.version_id,
        'serial_number': value.serial_number,
        'step': value.step,
        'melco_customer_id': value.melco_customer_id,
        'language': value.language,
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'renewal_date': value.renewal_date === undefined ? undefined : (value.renewal_date === null ? null : value.renewal_date.toISOString()),
        'expiration_date': value.expiration_date === undefined ? undefined : (value.expiration_date === null ? null : value.expiration_date.toISOString()),
    };
}


